export const btnsNamesConstants = {
    activate: "Activate",
    add: "Add",
    archive: "Archive",
    archived: "Archived",
    assign: "Assign",
    cancel: "Cancel",
    clearFilters: "Clear Filters",
    copy: "Copy",
    copyEventLink: "Copy Event Link",
    copySlideshowLink: "Copy Slideshow Link",
    copyUppercase: "COPY",
    create: "Create",
    createTemplateFromEvent: "Create Template From Event",
    deactivate: "Deactivate",
    deleteAction: "Delete",
    display: "Display",
    download: "Download",
    downloadQRCode: "Download QR Code",
    email: "Email",
    exportData: "Export Data",
    filter: "Filter",
    galleryActions: "Gallery Actions",
    generateZipFolder: "Generate Event Archive",
    inCurrentPage: "In Current Page",
    inEvent: "In Event",
    login: "Login",
    openSlideshowPreview: "Open Slideshow Preview",
    phone: "Phone",
    print: "Print",
    reload: "Reload",
    remove: "Remove",
    resend: "Resend",
    save: "Save",
    saveUppercase: "SAVE",
    selectAll: "Select All",
    selectPhotos: "Select Photos",
    send: "Send",
    setAsDefault: "Set as Default",
    shareSelected: "Share selected",
    shareToAll: "Share to all",
    sort: "Sort",
    submit: "Submit",
    unarchive: "Unarchive",
    unarchived: "Active",
    update: "Update",
    upload: "Upload",
};
